import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-0"}]]

const IconNumber0Small = createReactComponent('outline', 'number-0-small', 'Number0Small', __iconNode);

export default IconNumber0Small;